<template>
  <v-container fluid>
    <v-container fluid ref="content" id="editor">
      <!-- <v-layout justify-center>
        <h4 class="headline font-weight-black">
          {{ data.company ? data.company.toUpperCase() : "" }}
        </h4>
      </v-layout> -->

      <v-layout justify-center>
        <h3>
          {{ data.sub_company ? data.sub_company.toUpperCase() + " -" : "" }}
          END OF DAY REPORT
        </h3>
      </v-layout>

      <table class="data-table mt-2" style="width: 100%;">
        <tr>
          <th colspan="2" class="data-th font-weight-black">
            <p>TERMINAL:</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>{{ data.terminal ? data.terminal.toUpperCase() : "-" }}</p>
          </th>
          <th colspan="2" class="data-th font-weight-black">
            <p>CASHIER:</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>{{ data.cashier ? data.cashier.toUpperCase() : "-" }}</p>
          </th>
          <!-- <th colspan="2" class="data-th font-weight-black">
            <p>DRIVER</p>
          </th> -->
          <!-- <th colspan="2" class="data-th font-weight-regular">
            <p>{{ data.driver_name ? data.driver_name.toUpperCase() : "-" }}</p>
          </th> -->
          <th colspan="2" class="data-th font-weight-black">
            <p>START SHIFT (DATE AND TIME):</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>
              {{
                data.date_start
                  ? $dateFormat(data.date_start, "MM/DD/YYYY hh:mm:ss A")
                  : "-"
              }}
            </p>
          </th>
        </tr>
        <!-- <tr>
          <th colspan="2" class="data-th font-weight-black">
            <p>EMPLOYEE NO.</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>{{ data.conductor_no ? data.conductor_no.toUpperCase() : "-" }}</p>
          </th>
          <th colspan="2" class="data-th font-weight-black">
            <p>CONDUCTOR</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>{{ data.conductor_name ? data.conductor_name.toUpperCase() : "-" }}</p>
          </th>
          <th colspan="2" class="data-th font-weight-black">
            <p>DATE AND TIME REMIT</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>
              {{ $dateFormat(
              data.remittance_date,"MM/DD/YYYY hh:mm:ss A") }}
            </p>
          </th>
        </tr> -->
        <tr>
          <th colspan="2" class="data-th font-weight-black">
            <p>CONTROL NUMBER:</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>{{ data.control_no ? data.control_no : "-" }}</p>
          </th>
          <th colspan="2" class="data-th font-weight-black">
            <p>DEVICE SERIAL NUMBER:</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>{{ data.device_serial ? data.device_serial : "-" }}</p>
          </th>
          <!-- <th colspan="2" class="data-th font-weight-black">
            <p>TERMINAL</p>
          </th> -->
          <!-- <th colspan="2" class="data-th font-weight-regular">
            <p>{{data.terminal_name ? data.terminal_name.toUpperCase() : "-"}}</p>
          </th> -->

          <th colspan="2" class="data-th font-weight-black">
            <p>END SHIFT (DATE AND TIME):</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>
              {{
                data.date_end
                  ? $dateFormat(data.date_end, "MM/DD/YYYY hh:mm:ss A")
                  : "-"
              }}
            </p>
          </th>

          <!-- <tr>
          <th colspan="6" class="data-th font-weight-black">
            <p>{{ `${data.sub_company_code === 'DLTB' ? 'TOR NUMBER' : 'CONTROL NUMBER'}: ${data.control_no}` }}</p>
          </th>
          <th colspan="6" class="data-th font-weight-black">
            <p>DEVICE SERIAL: {{ data.device_serial }}</p>
          </th>
        </tr> -->
        </tr>
      </table>

      <table class="data-table-2 mt-2" style="width: 100%;">
        <tr>
          <th class="data-th" colspan="54" bgcolor="#E0E0E0">
            <p>SUMMARY</p>
          </th>
        </tr>
        <tr>
          <th colspan="54" class="data-th-3 font-weight-regular"></th>
        </tr>

        <tr>
          <th colspan="6" class="font-weight-regular">
            <p class="right">{{ data.book_count }}</p>
          </th>

          <th colspan="10" class="data-th-3 font-weight-regular">
            <p class="center">TICKET COUNT</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="10" class="data-th-3 font-weight-regular">
            <p class="center">TICKET TOTAL</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular"></th>

          <th colspan="6" class="data-th-3 font-weight-regular"></th>

          <th colspan="6" class="data-th-3   font-weight-regular">
            <p class="right"></p>
          </th>
        </tr>

        <tr>
          <th colspan="6" class="data-th-3 font-weight-regular"></th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">BOOK</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{ data.book_total ? data.book_total.count : 0 }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">BOOK</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{
                data.book_total
                  ? $amountInPeso(data.book_total.total_amount)
                  : $amountInPeso(0)
              }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left no-wrap">TOTAL CASH SALES</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{
                data.summary
                  ? $amountInPeso(data.summary.total_cash_sales)
                  : $amountInPeso(0)
              }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>
        </tr>

        <tr>
          <th colspan="6" class="data-th-3 font-weight-regular"></th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">REBOOK</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{ data.rebook_total ? data.rebook_total.count : 0 }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">REBOOK</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{
                data.rebook_total
                  ? $amountInPeso(data.rebook_total.rebook_amount)
                  : $amountInPeso(0)
              }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left no-wrap">TOTAL CARD SALES</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{
                data.summary
                  ? $amountInPeso(data.summary.total_card_sales)
                  : $amountInPeso(0)
              }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>
        </tr>

        <tr>
          <th colspan="6" class="data-th-3 font-weight-regular"></th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">REPRINT</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{ data.reprint_total ? data.reprint_total.count : 0 }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">REPRINT</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{
                data.reprint_total
                  ? $amountInPeso(data.reprint_total.reprint_amount)
                  : $amountInPeso(0)
              }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular"></th>

          <th colspan="6" class="data-th-3 font-weight-regular"></th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>
        </tr>

        <tr>
          <th colspan="6" class="data-th-3 font-weight-regular"></th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">BAGGAGE</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">0</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">BAGGAGE</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">{{ $amountInPeso(0) }}</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">GROSS REVENUE</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{
                data.summary
                  ? $amountInPeso(data.summary.total)
                  : $amountInPeso(0)
              }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>
        </tr>

        <tr>
          <th colspan="6" class="data-th-3 font-weight-regular"></th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">CANCEL</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{ data.cancel_total ? data.cancel_total.count : 0 }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">CANCEL</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{
                data.cancel_total
                  ? $amountInPeso(data.cancel_total.cancel_amount)
                  : $amountInPeso(0)
              }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left no-wrap">REMITTANCE AMOUNT</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{
                data.summary
                  ? $amountInPeso(data.summary.remittance_amount)
                  : $amountInPeso(0)
              }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>
        </tr>

        <tr>
          <th colspan="6" class="data-th-3 font-weight-regular"></th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">REFUND</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{ data.refund_total ? data.refund_total.count : 0 }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular">
            <p class="left">REFUND</p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right">
              {{
                data.refund_total
                  ? $amountInPeso(data.refund_total.refund_amount)
                  : $amountInPeso(0)
              }}
            </p>
          </th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>

          <th colspan="4" class="data-th-3 font-weight-regular"></th>

          <th colspan="6" class="data-th-3 font-weight-regular"></th>

          <th colspan="6" class="data-th-3 font-weight-regular">
            <p class="right"></p>
          </th>
        </tr>

        <tr></tr>
        <th colspan="54" class="data-th-3 font-weight-regular"></th>
      </table>

      <table class="data-table" style="width: 100%;">
        <thead>
          <tr>
            <th class="data-th" colspan="55" bgcolor="#E0E0E0">
              <p>BOOK TICKETS</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" colspan="7">
              <p>ROUTE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>ORIGIN</p>
            </th>
            <th class="data-th" colspan="5">
              <p>DESTINATION</p>
            </th>
            <th class="data-th" colspan="5">
              <p>DEP. DATE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>DEP. TIME</p>
            </th>
            <th class="data-th" colspan="5">
              <p>VEHICLE TYPE</p>
            </th>
            <th class="data-th" colspan="3">
              <p>SEAT NO.</p>
            </th>
            <th class="data-th" colspan="5">
              <p>PASSENGER TYPE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>FARE AMOUNT</p>
            </th>
            <th class="data-th" colspan="5">
              <p>ADD ONS AMOUNT</p>
            </th>
            <th class="data-th" colspan="5">
              <p>TOTAL AMOUNT</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-if="
              data.book_transactions ? data.book_transactions.length : false
            "
          >
            <tr v-for="(item, i) in data.book_transactions" :key="i">
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.route ? item.route.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.origin ? item.origin.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.destination ? item.destination.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "MM/DD/YYYY")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "hh:mm:ss A")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.vehicle_type ? item.vehicle_type.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{ item.seat_no ? item.seat_no.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{
                  item.passenger_type ? item.passenger_type.toUpperCase() : "-"
                }}
              </th>
              <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{
                  item.fare_amount
                    ? $amountInPeso(item.fare_amount)
                    : $amountInPeso(0)
                }}
              </th>
              <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{
                  item.add_ons_amount
                    ? $amountInPeso(item.add_ons_amount)
                    : $amountInPeso(0)
                }}
              </th>
              <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{
                  item.total_amount
                    ? $amountInPeso(item.total_amount)
                    : $amountInPeso(0)
                }}
              </th>
            </tr>

            <tr>
              <th class="data-th-3" colspan="7">TOTAL</th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="3"></th>
              <th class="data-th-3" colspan="5">
                {{ data.book_total ? data.book_total.count : 0 }}
              </th>
              <th class="data-th-3 text-xs-right" colspan="5">
                {{
                  data.book_total
                    ? $amountInPeso(data.book_total.fare_amount)
                    : $amountInPeso(0)
                }}
              </th>
              <th class="data-th-3 text-xs-right" colspan="5">
                {{
                  data.book_total
                    ? $amountInPeso(data.book_total.add_ons_amount)
                    : $amountInPeso(0)
                }}
              </th>
              <th class="data-th-3 text-xs-right" colspan="5">
                {{
                  data.book_total
                    ? $amountInPeso(data.book_total.total_amount)
                    : $amountInPeso(0)
                }}
              </th>
            </tr>
          </template>

          <tr v-else>
            <th class="data-th" colspan="55">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>

      <table class="data-table" style="width: 100%;">
        <thead>
          <tr>
            <th class="data-th" colspan="45" bgcolor="#E0E0E0">
              <p>REBOOK TICKETS</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" colspan="7">
              <p>ROUTE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>ORIGIN</p>
            </th>
            <th class="data-th" colspan="5">
              <p>DESTINATION</p>
            </th>
            <th class="data-th" colspan="5">
              <p>DEP. DATE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>DEP. TIME</p>
            </th>
            <th class="data-th" colspan="5">
              <p>VEHICLE TYPE</p>
            </th>
            <th class="data-th" colspan="3">
              <p>SEAT NO.</p>
            </th>
            <th class="data-th" colspan="5">
              <p>PASSENGER TYPE</p>
            </th>
            <!-- <th class="data-th" colspan="5">
              <p>FINAL FARE</p>
            </th> -->
            <th class="data-th" colspan="5">
              <p>REBOOK AMOUNT</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-if="
              data.rebook_transactions ? data.rebook_transactions.length : false
            "
          >
            <tr v-for="(item, i) in data.rebook_transactions" :key="i">
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.route ? item.route.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.origin ? item.origin.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.destination ? item.destination.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "MM/DD/YYYY")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "hh:mm:ss A")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.vehicle_type ? item.vehicle_type.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{ item.seat_no ? item.seat_no.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{
                  item.passenger_type ? item.passenger_type.toUpperCase() : "-"
                }}
              </th>

              <!-- <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{
                  item.final_fare
                    ? $amountInPeso(item.final_fare)
                    : $amountInPeso(0)
                }}
              </th> -->

              <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{
                  item.rebook_amount
                    ? $amountInPeso(item.rebook_amount)
                    : $amountInPeso(0)
                }}
              </th>
            </tr>

            <tr>
              <th class="data-th-3" colspan="7">TOTAL</th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="3"></th>
              <th class="data-th-3" colspan="5">
                {{ data.rebook_total ? data.rebook_total.count : 0 }}
              </th>

              <!-- <th class="data-th-3 text-xs-right" colspan="5">
                {{
                  data.rebook_total
                    ? $amountInPeso(data.rebook_total.final_fare)
                    : $amountInPeso(0)
                }}
              </th> -->
              <th class="data-th-3 text-xs-right" colspan="5">
                {{
                  data.rebook_total
                    ? $amountInPeso(data.rebook_total.rebook_amount)
                    : $amountInPeso(0)
                }}
              </th>
            </tr>
          </template>

          <tr v-else>
            <th class="data-th" colspan="45">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>

      <table class="data-table" style="width: 100%;">
        <thead>
          <tr>
            <th class="data-th" colspan="50" bgcolor="#E0E0E0">
              <p>REPRINT TICKETS</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" colspan="7">
              <p>ROUTE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>ORIGIN</p>
            </th>
            <th class="data-th" colspan="5">
              <p>DESTINATION</p>
            </th>
            <th class="data-th" colspan="4">
              <p>DEP. DATE</p>
            </th>
            <th class="data-th" colspan="4">
              <p>DEP. TIME</p>
            </th>
            <th class="data-th" colspan="5">
              <p>VEHICLE TYPE</p>
            </th>
            <th class="data-th" colspan="3">
              <p>SEAT NO.</p>
            </th>
            <th class="data-th" colspan="5">
              <p>PASSENGER TYPE</p>
            </th>
            <th class="data-th" colspan="7">
              <p>HEAD CASHIER</p>
            </th>
            <th class="data-th" colspan="5">
              <p>REPRINT AMOUNT</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-if="
              data.reprint_transactions
                ? data.reprint_transactions.length
                : false
            "
          >
            <tr v-for="(item, i) in data.reprint_transactions" :key="i">
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.route ? item.route.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.origin ? item.origin.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.destination ? item.destination.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="4">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "MM/DD/YYYY")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="4">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "hh:mm:ss A")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.vehicle_type ? item.vehicle_type.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{ item.seat_no ? item.seat_no.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{
                  item.passenger_type ? item.passenger_type.toUpperCase() : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.head_cashier ? item.head_cashier.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{
                  item.reprint_amount
                    ? $amountInPeso(item.reprint_amount)
                    : $amountInPeso(0)
                }}
              </th>
            </tr>

            <tr>
              <th class="data-th-3" colspan="7">TOTAL</th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="4"></th>
              <th class="data-th-3" colspan="4"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="3"></th>
              <th class="data-th-3" colspan="5">
                {{ data.reprint_total ? data.reprint_total.count : 0 }}
              </th>
              <th class="data-th-3 text-xs-right" colspan="7"></th>
              <th class="data-th-3 text-xs-right" colspan="5">
                {{
                  data.reprint_total
                    ? $amountInPeso(data.reprint_total.reprint_amount)
                    : $amountInPeso(0)
                }}
              </th>
            </tr>
          </template>

          <tr v-else>
            <th class="data-th" colspan="50">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>

      <table class="data-table" style="width: 100%;">
        <thead>
          <tr>
            <th class="data-th" colspan="50" bgcolor="#E0E0E0">
              <p>CANCEL TICKETS</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" colspan="7">
              <p>ROUTE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>ORIGIN</p>
            </th>
            <th class="data-th" colspan="5">
              <p>DESTINATION</p>
            </th>
            <th class="data-th" colspan="4">
              <p>DEP. DATE</p>
            </th>
            <th class="data-th" colspan="4">
              <p>DEP. TIME</p>
            </th>
            <th class="data-th" colspan="5">
              <p>VEHICLE TYPE</p>
            </th>
            <th class="data-th" colspan="3">
              <p>SEAT NO.</p>
            </th>
            <th class="data-th" colspan="5">
              <p>PASSENGER TYPE</p>
            </th>
            <th class="data-th" colspan="7">
              <p>HEAD CASHIER</p>
            </th>
            <th class="data-th" colspan="5">
              <p>CANCEL AMOUNT</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-if="
              data.cancel_transactions ? data.cancel_transactions.length : false
            "
          >
            <tr v-for="(item, i) in data.cancel_transactions" :key="i">
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.route ? item.route.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.origin ? item.origin.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.destination ? item.destination.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="4">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "MM/DD/YYYY")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="4">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "hh:mm:ss A")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.vehicle_type ? item.vehicle_type.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{ item.seat_no ? item.seat_no.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{
                  item.passenger_type ? item.passenger_type.toUpperCase() : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.head_cashier ? item.head_cashier.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{ item.cancel_amount ? $amountInPeso(item.cancel_amount) : 0 }}
              </th>
            </tr>

            <tr>
              <th class="data-th-3" colspan="7">TOTAL</th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="4"></th>
              <th class="data-th-3" colspan="4"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="3"></th>
              <th class="data-th-3" colspan="5">
                {{ data.cancel_total ? data.cancel_total.count : 0 }}
              </th>
              <th class="data-th-3 text-xs-right" colspan="7"></th>
              <th class="data-th-3 text-xs-right" colspan="5">
                {{
                  data.cancel_total
                    ? $amountInPeso(data.cancel_total.cancel_amount)
                    : $amountInPeso(0)
                }}
              </th>
            </tr>
          </template>

          <tr v-else>
            <th class="data-th" colspan="50">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>

      <table class="data-table" style="width: 100%;">
        <thead>
          <tr>
            <th class="data-th" colspan="50" bgcolor="#E0E0E0">
              <p>REFUND TICKETS</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" colspan="7">
              <p>ROUTE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>ORIGIN</p>
            </th>
            <th class="data-th" colspan="5">
              <p>DESTINATION</p>
            </th>
            <th class="data-th" colspan="4">
              <p>DEP. DATE</p>
            </th>
            <th class="data-th" colspan="4">
              <p>DEP. TIME</p>
            </th>
            <th class="data-th" colspan="5">
              <p>VEHICLE TYPE</p>
            </th>
            <th class="data-th" colspan="3">
              <p>SEAT NO.</p>
            </th>
            <th class="data-th" colspan="5">
              <p>PASSENGER TYPE</p>
            </th>
            <th class="data-th" colspan="7">
              <p>HEAD CASHIER</p>
            </th>
            <!-- <th class="data-th" colspan="5">
              <p>BOOK AMOUNT</p>
            </th> -->
            <th class="data-th" colspan="5">
              <p>REFUND AMOUNT</p>
            </th>
            <!-- <th class="data-th" colspan="5">
              <p>TOTAL AMOUNT</p>
            </th> -->
          </tr>
        </thead>
        <tbody>
          <template
            v-if="
              data.refund_transactions ? data.refund_transactions.length : false
            "
          >
            <tr v-for="(item, i) in data.refund_transactions" :key="i">
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.route ? item.route.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.origin ? item.origin.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.destination ? item.destination.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="4">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "MM/DD/YYYY")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="4">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "hh:mm:ss A")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.vehicle_type ? item.vehicle_type.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{ item.seat_no ? item.seat_no.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{
                  item.passenger_type ? item.passenger_type.toUpperCase() : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.head_cashier ? item.head_cashier.toUpperCase() : "-" }}
              </th>
              <!-- <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{ item.book_amount ? item.book_amount : 0 }}
              </th> -->
              <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{ item.refund_amount ? $amountInPeso(item.refund_amount) : 0 }}
              </th>
              <!-- <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{ item.total_amount ? item.total_amount : 0 }}
              </th> -->
            </tr>

            <tr>
              <th class="data-th-3" colspan="7">TOTAL</th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="4"></th>
              <th class="data-th-3" colspan="4"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="3"></th>
              <th class="data-th-3" colspan="5">
                {{ data.refund_total ? data.refund_total.count : 0 }}
              </th>
              <th class="data-th-3 text-xs-right" colspan="7"></th>
              <!-- <th class="data-th-3 text-xs-right" colspan="5">
                {{
                  data.refund_total
                    ? $amountInPeso(data.refund_total.book_amount)
                    : $amountInPeso(0)
                }}
              </th> -->
              <th class="data-th-3 text-xs-right" colspan="5">
                {{
                  data.refund_total
                    ? $amountInPeso(data.refund_total.refund_amount)
                    : $amountInPeso(0)
                }}
              </th>
              <!-- <th class="data-th-3 text-xs-right" colspan="5">
                {{
                  data.refund_total.total_amount
                    ? $amountInPeso(data.refund_total.total_amount)
                    : $amountInPeso(0)
                }}
              </th> -->
            </tr>
          </template>

          <tr v-else>
            <th class="data-th" colspan="40">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>

      <table class="data-table" style="width: 100%;">
        <thead>
          <tr>
            <th class="data-th" colspan="47" bgcolor="#E0E0E0">
              <p>BAGGAGE TICKETS</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" colspan="7">
              <p>ROUTE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>ORIGIN</p>
            </th>
            <th class="data-th" colspan="5">
              <p>DESTINATION</p>
            </th>
            <th class="data-th" colspan="4">
              <p>DEP. DATE</p>
            </th>
            <th class="data-th" colspan="4">
              <p>DEP. TIME</p>
            </th>
            <th class="data-th" colspan="5">
              <p>VEHICLE TYPE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>PASSENGER TYPE</p>
            </th>
            <th class="data-th" colspan="7">
              <p>DESCRIPTION</p>
            </th>
            <th class="data-th" colspan="5">
              <p>BAGGAGE AMOUNT</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-if="
              data.baggage_transactions
                ? data.baggage_transactions.length
                : false
            "
          >
            <tr v-for="(item, i) in data.baggage_transactions" :key="i">
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.route ? item.route.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.origin ? item.origin.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.destination ? item.destination.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="4">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "MM/DD/YYYY")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="4">
                {{
                  item.departure_datetime
                    ? $dateFormat(item.departure_datetime, "hh:mm:ss A")
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.vehicle_type ? item.vehicle_type.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{ item.seat_no ? item.seat_no.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{
                  item.passenger_type ? item.passenger_type.toUpperCase() : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.head_cashier ? item.head_cashier.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{ item.book_amount ? item.book_amount : 0 }}
              </th>
              <th class="data-th font-weight-regular text-xs-right" colspan="5">
                {{ item.refund_amount ? item.refund_amount : 0 }}
              </th>
            </tr>

            <tr>
              <th class="data-th-3" colspan="7">TOTAL</th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="4"></th>
              <th class="data-th-3" colspan="4"></th>
              <th class="data-th-3" colspan="5"></th>
              <th class="data-th-3" colspan="3"></th>
              <th class="data-th-3" colspan="5">0</th>
              <th class="data-th-3 text-xs-right" colspan="7"></th>
              <th class="data-th-3 text-xs-right" colspan="5">
                {{ rebook_amount ? rebook_amount : 0 }}
              </th>

              <th class="data-th-3 text-xs-right" colspan="5">
                {{ rebook_amount ? rebook_amount : 0 }}
              </th>
            </tr>
          </template>

          <tr v-else>
            <th class="data-th" colspan="47">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>
    </v-container>
    <ticket-details-dialog
      :dataTicket="dataTicket"
      :data="trip"
      :route="route"
      ref="ticket"
    ></ticket-details-dialog>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
import TicketDetailsDialog from "@/components/TicketDetailDialog";
export default {
  components: {
    TicketDetailsDialog,
  },
  props: {
    data: Object,
    eodDate: String,
    setting: Object,
  },
  data() {
    return {
      trip: {},
      dataTicket: [],
      route: "",
    };
  },
  watch: {},
  methods: {
    async openDialog(id) {
      this.dataTicket = [];
      this.trip = {};

      try {
        this.trip = this.data;
        this.route = this.data.ticket_issuance[0].route_name;

        const response = (await Services.getEndOfDayTickets(
          id.dispatch_sync_id
        )).data;
        const dataTicket = response.data;
        this.dataTicket = dataTicket;

        this.$refs.ticket.openDialog();
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      return this.trip;
    },
    async openBaggageDialog(id) {
      this.dataTicket = [];
      this.trip = {};

      try {
        this.trip = this.data;
        this.route = this.data.ticket_issuance[0].route_name;

        const response = (await Services.getEndOfDayBaggages(
          id.dispatch_sync_id
        )).data;
        const dataTicket = response.data;
        this.dataTicket = dataTicket;

        this.$refs.ticket.openDialog();
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      return this.trip;
    },
    sortPassenger(data) {
      let sorted = [];

      sorted = data.sort((a, b) =>
        a.index > b.index ? 1 : b.index > a.index ? -1 : 0
      );

      return sorted;
    },
  },
};
</script>

<style scoped>
p {
  margin: auto;
  word-break: break-all;
  word-wrap: break-word;
}
.data-table {
  border: 3px solid;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
  table-layout: fixed;
}
.data-table-2 {
  border: 3px solid;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
  table-layout: fixed;
}
.data-th {
  text-align: center;
  font-size: 12px;
  border: 1px solid black;
  padding: 10px;
}

.data-th-2 {
  font-size: 12px;
  border: 1px solid black;
  padding: 10px;
  text-align: left;
}
.data-th-3 {
  text-align: center;
  font-size: 12px;
  border: 0;
  padding: 10px;
}
</style>
